export var max = Math.max;
export var min = Math.min;
export var round = Math.round;


//////////////////
// WEBPACK FOOTER
// /home/runner/work/proj-strada-website/proj-strada-website/src/web/app/themes/strada/node_modules/@popperjs/core/lib/utils/math.js
// module id = 7
// module chunks = 0